import React, { useState, useEffect } from "react";
import InstantFeedbackView from "./InstantFeedback.view.js"
import * as Database from './database'

const InstantFeedback = (props) => {
    const [_data, _setData] = useState(props.data)

    useEffect(() => {
        _setData(props.data)
    }, [props.data])

    const saveAssessment = async (assessment) => {
        await Database.save({..._data, ...assessment});
    }

    return (
        <InstantFeedbackView handleOnSelected={saveAssessment} />
    )
}

export default InstantFeedback
